export const LOCALE_PREFIX = 'services.api'
